import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    templateUrl: './usedCarsNotAcceptedDialog.component.html',
    styleUrls: ['./modal.css', './usedCarsNotAcceptedDialog.component.css'],
    standalone: false
})
export class UsedCarsNotAcceptedDialogComponent implements OnInit {

    customerNames: string[];

    constructor(public dialogRef: MatDialogRef<UsedCarsNotAcceptedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { 
        this.customerNames = data.customerNames;
    }

    ngOnInit(): void {
        // nothing to initialize yet
    }

    ok(): void {
        this.dialogRef.close(true);
    }

    cancel(): void {
        this.dialogRef.close(false);
    }
}
